import {
    setNavigation
} from './actions';


const dispatchNavigation = (dispatch: any) => (navigationTab: any) => {
    dispatch(setNavigation(navigationTab));
};

const operations = {
    dispatchNavigation
};

export default operations;
